'use strict';

var name = "@nrk/core-scroll";
var version = "3.1.1";

var IS_BROWSER = typeof window !== 'undefined';
var IS_ANDROID = IS_BROWSER && /(android)/i.test(navigator.userAgent); // Bad, but needed
var IS_IOS = IS_BROWSER && /iPad|iPhone|iPod/.test(String(navigator.platform));
var HAS_EVENT_OPTIONS = (function (has) {
  if ( has === void 0 ) has = false;

  try { window.addEventListener('test', null, { get passive () { has = true; } }); } catch (e) {}
  return has
})();

/**
* addEvent
* @param {String} uuid An unique ID of the event to bind - ensurnes single instance
* @param {String} type The type of event to bind
* @param {Function} handler The function to call on event
* @param {Boolean|Object} options useCapture or options object for addEventListener. Defaults to false
*/
function addEvent (uuid, type, handler, options) {
  if ( options === void 0 ) options = false;

  if (typeof window === 'undefined' || window[uuid = uuid + "-" + type]) { return } // Ensure single instance
  if (!HAS_EVENT_OPTIONS && typeof options === 'object') { options = Boolean(options.capture); } // Fix unsupported options
  var node = (type === 'resize' || type === 'load') ? window : document;
  node.addEventListener(window[uuid] = type, handler, options);
}

/**
* dispatchEvent - with infinite loop prevention
* @param {Element} elem The target object
* @param {String} name The source object(s)
* @param {Object} detail Detail object (bubbles and cancelable is set to true)
* @return {Boolean} Whether the event was canceled
*/
var IGNORE = 'prevent_recursive_dispatch_maximum_callstack';
function dispatchEvent (element, name, detail) {
  if ( detail === void 0 ) detail = {};

  var ignore = "" + IGNORE + name;
  var event;

  if (element[ignore]) { return true } // We are already processing this event, so skip sending a new one
  else { element[ignore] = true; } // Add name to dispatching ignore

  if (typeof window.CustomEvent === 'function') {
    event = new window.CustomEvent(name, { bubbles: true, cancelable: true, detail: detail });
  } else {
    event = document.createEvent('CustomEvent');
    event.initCustomEvent(name, true, true, detail);
  }
  // IE reports incorrect event.defaultPrevented
  // but correct return value on element.dispatchEvent
  var result = element.dispatchEvent(event);
  element[ignore] = null; // Remove name from dispatching ignore

  return result // Follow W3C standard for return value
}

/**
* requestAnimFrame (super simple polyfill)
*/
function requestAnimFrame (fn) {
  (window.requestAnimationFrame || window.setTimeout)(fn);
}

/**
 * throttle
 * @param {Function} callback  The new throttled function
 * @param {Number} ms The threshold of milliseconds between each callback
 */
function throttle (callback, ms) {
  var timer;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (!timer) {
      timer = setTimeout(function () {
        callback.apply(this, args);
        timer = null;
      }, ms);
    }
  }
}

/**
* queryAll
* @param {String|NodeList|Array|Element} elements A CSS selector string, nodeList, element array, or single element
* @return {Element[]} Array of elements
*/
function queryAll (elements, context) {
  if ( context === void 0 ) context = document;

  if (elements) {
    if (elements.nodeType) { return [elements] }
    if (typeof elements === 'string') { return [].slice.call(context.querySelectorAll(elements)) }
    if (elements.length) { return [].slice.call(elements) }
  }
  return []
}

var DRAG = {};
var ATTR = 'data-core-scroll';
var UUID = ("data-" + name + "-" + version).replace(/\W+/g, '-'); // Strip invalid attribute characters
var MOVE = { up: { y: -1, prop: 'top' }, down: { y: 1, prop: 'bottom' }, left: { x: -1 }, right: { x: 1 } };
var SIGNIFICANT_DRAG_THRESHOLD = 10;
var FRICTION = 0.8;
var VELOCITY = 20;
var NEEDS_MOUSEDOWN = /INPUT|TEXTAREA|SELECT/;

// https://css-tricks.com/introduction-reduced-motion-media-query/
var requestJump = IS_BROWSER && window.matchMedia && window.matchMedia('(prefers-reduced-motion)').matches;

function scroll (elements, move) {
  if ( move === void 0 ) move = '';

  var options = typeof move === 'object' ? move : { move: move };
  var isChange = 'x' in options || 'y' in options || options.move;

  return queryAll(elements).map(function (target) {
    if (!target.hasAttribute(UUID)) { // Reduce read / write operations
      target.setAttribute(UUID, options.friction || '');
      hideScrollbars(target);
    }
    if (isChange) { scrollTo(target, parsePoint(target, options)); }
    else { onChange(target); } // Updates button states
    return target
  })
}

addEvent(UUID, 'mousedown', onMousedown);
addEvent(UUID, 'resize', throttle(onChange, 500)); // Update button states on resize
addEvent(UUID, 'scroll', throttle(onChange, 500), { passive: true, capture: true }); // capture catches events without bubbling
addEvent(UUID, 'wheel', function () { return (DRAG.animate = false); }, { passive: true }); // Stop animation on wheel scroll
addEvent(UUID, 'load', onChange); // Update state when we are sure all CSS is loaded
addEvent(UUID, 'click', onClick);

function onMousedown (event) {
  for (var el = event.target; el; el = el.parentElement) {
    if (el.contentEditable === 'true' || NEEDS_MOUSEDOWN.test(el.nodeName)) { return } // No dragging when user clicks input fields
    if (!event.defaultPrevented && el.hasAttribute && el.hasAttribute(UUID)) {
      event.preventDefault(); // Prevent text selection and enable nesting

      DRAG.pageX = event.pageX;
      DRAG.pageY = event.pageY;
      DRAG.diffSumX = 0;
      DRAG.diffSumY = 0;
      DRAG.scrollX = el.scrollLeft;
      DRAG.scrollY = el.scrollTop;
      DRAG.animate = DRAG.diffX = DRAG.diffY = 0; // Reset
      DRAG.target = el;

      document.body.style.cursor = el.style.cursor = '-webkit-grabbing';
      document.body.style.cursor = el.style.cursor = 'grabbing';
      document.addEventListener('mousemove', onMousemove);
      document.addEventListener('mouseup', onMouseup);
    }
  }
}

function hideScrollbars (element) {
  if (!document.getElementById(UUID)) { // Hide scrollbar in WebKit
    document.head.insertAdjacentHTML('beforeend',
      ("<style id=\"" + UUID + "\">[" + UUID + "]::-webkit-scrollbar{display:none}</style>"));
  }

  element.style.overflow = 'scroll'; // Ensure visible scrollbars
  element.style.willChange = 'scroll-position'; // Enhance performance
  element.style.webkitOverflowScrolling = 'touch'; // Momentum scoll on iOS

  // Calculate sizes for hiding, must be after setting overflow:scroll
  var barWidth = element.offsetWidth - element.clientWidth;
  var barHeight = element.offsetHeight - element.clientHeight;

  // Also ensure height does not grow higher than parent element
  element.style.marginRight = "-" + barWidth + "px";
  element.style.marginBottom = "-" + barHeight + "px";
  element.style.maxHeight = "calc(100% + " + barHeight + "px)";
}

/**
 * Check that the current drag is significant.
 *
 * When the user clicks on an element and the cursor moves slightly, it is most
 * likely that the user wanted to click in stead of drag.
 */
function isSignificantDrag () {
  return (
    Math.abs(DRAG.diffSumX) > SIGNIFICANT_DRAG_THRESHOLD ||
    Math.abs(DRAG.diffSumY) > SIGNIFICANT_DRAG_THRESHOLD
  )
}

function onMousemove (event) {
  DRAG.diffX = DRAG.pageX - (DRAG.pageX = event.pageX);
  DRAG.diffY = DRAG.pageY - (DRAG.pageY = event.pageY);
  DRAG.diffSumX += DRAG.diffX;
  DRAG.diffSumY += DRAG.diffY;
  DRAG.target.scrollLeft = DRAG.scrollX += DRAG.diffX;
  DRAG.target.scrollTop = DRAG.scrollY += DRAG.diffY;
  if (isSignificantDrag()) {
    DRAG.target.style.pointerEvents = 'none'; // Prevent links when we know there has been movement
  }
}

function onMouseup (event) {
  var isMomentum = DRAG.diffX || DRAG.diffY; // Click-drag-scrollbar will not create momentum
  document.removeEventListener('mousemove', onMousemove);
  document.removeEventListener('mouseup', onMouseup);
  document.body.style.cursor = '';
  onChange(DRAG.target);

  if (isMomentum) {
    scrollTo(DRAG.target, {
      x: DRAG.scrollX + DRAG.diffX * VELOCITY,
      y: DRAG.scrollY + DRAG.diffY * VELOCITY
    });
  }
  DRAG.target.style.pointerEvents = ''; // Allow events again
  DRAG.target = null; // Prevent memory leak
}

function onChange (event) {
  var target = event.target || event;
  if (event.type === 'resize' || event.type === 'load') { return queryAll(("[" + UUID + "]")).forEach(onChange) } // Update all
  if (target.hasAttribute && target.hasAttribute(UUID)) { // target can be document
    var detail = { left: target.scrollLeft, up: target.scrollTop };
    detail.right = target.scrollWidth - target.clientWidth - detail.left;
    detail.down = target.scrollHeight - target.clientHeight - detail.up;
    var cursor = (detail.left || detail.right || detail.up || detail.down) ? 'grab' : '';

    dispatchEvent(target, 'scroll.change', detail);

    if (!event.type) { // Do not change cursor while dragging
      target.style.cursor = "-webkit-" + cursor;
      target.style.cursor = cursor;
    }

    if (target.id) {
      queryAll(("[" + ATTR + "]")).forEach(function (el) {
        if (el.getAttribute(ATTR) === target.id) { el.disabled = !detail[el.value]; }
      });
    }
  }
}

function onClick (event) {
  if (event.defaultPrevented) { return }
  for (var el = event.target; el; el = el.parentElement) {
    var target = document.getElementById(el.getAttribute(ATTR));
    if (target && dispatchEvent(target, 'scroll.click', { move: el.value })) {
      return scroll(target, el.value)
    }
  }
}

function scrollTo (target, ref) {
  var x = ref.x;
  var y = ref.y;

  // Giving the animation an ID to workaround IE timeout issues
  var friction = Math.min(0.99, target.getAttribute(UUID)) || FRICTION; // Avoid friction 1 (infinite)
  var uuid = DRAG.animate = Math.floor(Date.now() * Math.random()).toString(16);
  var endX = Math.max(0, Math.min(x, target.scrollWidth - target.clientWidth));
  var endY = Math.max(0, Math.min(y, target.scrollHeight - target.clientHeight));
  var moveX = requestJump ? 1 : endX - target.scrollLeft;
  var moveY = requestJump ? 1 : endY - target.scrollTop;

  var move = function () {
    if (DRAG.animate === uuid && (Math.round(moveX) || Math.round(moveY))) {
      target.scrollLeft = endX - Math.round(moveX *= friction);
      target.scrollTop = endY - Math.round(moveY *= friction);
      requestAnimFrame(move);
    }
  };
  move();
}

function parsePoint (target, ref) {
  var x = ref.x;
  var y = ref.y;
  var move = ref.move;

  var point = { x: x, y: y, move: MOVE[move] };
  // {
  //   to: 'left|top|right|bottom|Element'
  //   x: 'left|top|right|bottom|px'
  //   y: 'left|top|right|bottom|px'
  // }
  if (typeof point.x !== 'number') { point.x = target.scrollLeft; }
  if (typeof point.y !== 'number') { point.y = target.scrollTop; }
  if (point.move) {
    var axis = point.move.x ? 'x' : 'y';
    var start = point.move.x ? 'left' : 'top';
    var bounds = target.getBoundingClientRect();
    var scroll = bounds[start] - target[point.move.x ? 'scrollLeft' : 'scrollTop'];
    var edge = bounds[start] + bounds[point.move.x ? 'width' : 'height'] * point.move[axis];

    queryAll(target.children).every(function (el) { // Use .every as this loop stops on return false
      var rect = el.getBoundingClientRect();
      var marg = el.ownerDocument.defaultView.getComputedStyle(el)[("margin-" + start)];

      point[axis] = rect[start] - parseInt(marg, 10) - scroll; // Update point to child axis coordinate
      return rect[point.move.prop || move] < edge
    });
  }
  return point
}

module.exports = scroll;
